export var SwitchState;
(function (SwitchState) {
    SwitchState[SwitchState["Normal"] = 0] = "Normal";
    SwitchState[SwitchState["Pressed"] = 1] = "Pressed";
})(SwitchState || (SwitchState = {}));
